import React, { useRef } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Grid,
  Modal,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { useStyles } from "./successPaymentModal.styles";
import CartSuccess from "../../../assets/images/CartSuccess.svg";
import { ArrowLeftIcon } from "../../../shared/icons";

export const SuccessPaymentModal = ({
  isModalOpen,
  handleCloseModal,
  redirectTo,
}) => {
  const ref = useRef();
  const classes = useStyles();
  const theme = useTheme();
  const small = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Modal
      ref={ref}
      open={isModalOpen}
      onClose={handleCloseModal}
      closeAfterTransition
      BackdropProps={{ timeout: 500 }}
    >
      <Box
        component={Grid}
        flexWrap="nowrap"
        justifyContent="center"
        alignItems="center"
        className={classes.modal}
      >
        <img src={CartSuccess} alt="success" />
        <Typography className={classes.title}>
          Your payment is confirmed!
        </Typography>
        <Typography className={classes.description}>
          Thank you for signing up for premium.
        </Typography>
        <Grid
          container
          direction={small ? "column-reverse" : "row"}
          justifyContent="flex-end"
          alignItems="center"
        >
          <Button
            onClick={redirectTo}
            className={classes.button}
            endIcon={<ArrowLeftIcon className={classes.arrowRight} />}
          >
            Continue
          </Button>
        </Grid>
      </Box>
    </Modal>
  );
};

SuccessPaymentModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  redirectTo: PropTypes.func.isRequired,
};
